import { Gift, Zap, CheckCircle2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const AuthPromptOverlay = ({ onLoginClick, onClose }) => {
  return (
    <div className="absolute inset-0 bg-black/80 backdrop-blur-md rounded-lg z-50 flex items-center justify-center p-4">
      <Card className="bg-white dark:bg-gray-800 w-full max-w-sm shadow-2xl relative border-2 border-purple-200 dark:border-purple-700 ring-4 ring-purple-100/50 dark:ring-purple-900/30">
        {/* Close Button */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors z-10"
            aria-label="Close"
          >
            <X className="w-4 h-4 text-gray-500 dark:text-gray-400" />
          </button>
        )}
        
        <div className="p-6">
          {/* Compact Icon */}
          <div className="text-center mb-4">
            <div className="inline-flex bg-gradient-to-r from-purple-500 to-indigo-500 rounded-xl p-3 mb-3">
              <Gift className="w-8 h-8 text-white" />
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1" style={{fontFamily: 'Space Grotesk'}}>
              Start Analyzing Your Content
            </h3>
            
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Create free account • Get started instantly
            </p>
          </div>
          
          {/* Hero CTA Button - Prominently placed with pulsing glow */}
          <div className="relative mb-5">
            {/* Animated pulsing glow rings - multiple layers for depth */}
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 via-pink-600 to-indigo-600 rounded-lg blur-md opacity-75 animate-glow-pulse"></div>
            <div className="absolute -inset-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-lg blur-xl opacity-50 animate-pulse"></div>
            
            <Button
              onClick={onLoginClick}
              size="lg"
              className="relative w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold text-lg py-7 shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105"
              style={{
                animation: 'pulse-subtle 2s ease-in-out infinite'
              }}
            >
              <div className="flex items-center justify-center gap-2">
                <Zap className="w-6 h-6 fill-white animate-pulse" />
                <span>Get 25 Free Credits</span>
                <Zap className="w-6 h-6 fill-white animate-pulse" />
              </div>
            </Button>
          </div>
          
          {/* Compact Benefits List */}
          <div className="space-y-2 mb-4">
            <div className="flex items-start gap-2 text-left">
              <CheckCircle2 className="w-4 h-4 text-green-600 dark:text-green-400 mt-0.5 flex-shrink-0" />
              <span className="text-xs text-gray-700 dark:text-gray-300">Instant emotional analysis</span>
            </div>
            <div className="flex items-start gap-2 text-left">
              <CheckCircle2 className="w-4 h-4 text-green-600 dark:text-green-400 mt-0.5 flex-shrink-0" />
              <span className="text-xs text-gray-700 dark:text-gray-300">Audience insights (20+ demographics)</span>
            </div>
            <div className="flex items-start gap-2 text-left">
              <CheckCircle2 className="w-4 h-4 text-green-600 dark:text-green-400 mt-0.5 flex-shrink-0" />
              <span className="text-xs text-gray-700 dark:text-gray-300">AI-powered recommendations</span>
            </div>
          </div>
          
          <p className="text-gray-500 dark:text-gray-400 text-xs text-center">
            No credit card required
          </p>
        </div>
      </Card>
    </div>
  );
};

export default AuthPromptOverlay;
